import {
  ItrMilestoneAction,
  ItrType,
  ProjectItrConfig,
  ProjectMilestoneType,
  SaveItrConfigInput,
} from '@bechtel/types';
import { FormikProps } from 'formik';

export interface ItrTypeExt {
  value: ItrType;
  description: string;
}

export interface ItrConfig {
  projectCommodityTypeItrId: SaveItrConfigInput['projectCommodityTypeItrId'];
  projectMilestoneType: ProjectMilestoneType;
}

export interface FormikState {
  itrConfigList: ItrConfig[];
  itrMilestoneAction: ItrMilestoneAction;
}

export interface ItrConfigItemProps {
  projectItrConfig: ProjectItrConfig;
  formikProps: FormikProps<FormikState>;
}
export enum MilestoneTypeId {
  NONE = 'NONE',
}
